



























































































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'home',
  components: {},
})
export default class HomePage extends Vue {
  get isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
}
